import { buildMarkdownPreviewSegments } from '../markdownEditor/markdownPreviewRender';
import { tipAssetMarkdownToDisplay } from './tipAssetMarkdown';

function decorateTipHtml(html: string): string {
  return html
    .replace(/<a(?![^>]*\btarget=)/gi, '<a target="_blank" rel="noopener noreferrer"')
    .replace(/<a ([^>]*\btarget="_blank")(?![^>]*\brel=)/gi, '<a $1 rel="noopener noreferrer"');
}

export function renderTipBodyHtml(markdown: string, assetUrl: (id: string) => string): string {
  const display = tipAssetMarkdownToDisplay(markdown, assetUrl);
  const html = buildMarkdownPreviewSegments(display)
    .filter((segment): segment is { type: 'html'; html: string } => segment.type === 'html')
    .map((segment) => segment.html)
    .join('');
  return decorateTipHtml(html);
}
